import { defineComponent as _defineComponent } from 'vue'
import { ValidatorBase } from '@/models/store/validator.js';
import {ref} from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ValidatorLogo',
  props: {
    validator: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const imageLoadingError = ref(false);

const props = __props;

function setAltImg(event:any) {
  imageLoadingError.value = true;
  console.log("(Img) Validator " + props.validator.description.moniker + " has wrong imag url. Cannot get content. Skipping. " + props.validator.description.pictureUrl);
}


const __returned__ = { imageLoadingError, props, setAltImg }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})